import PropTypes from 'prop-types'
import React from 'react'
import styles from './_step.css'

const propTypes = {
  title: PropTypes.string,
  number: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  children: PropTypes.node,
  onClick: PropTypes.func,
  style: PropTypes.object,
}

export function Step (props) {
  const {
    title,
    children,
    number,
    onClick,
    style,
  } = props

  return (
    <div className={styles.container} style={style}>
      <div className={styles.header} onClick={onClick}>
        {number ?
          <div className={styles.number}>{number}</div>
        : null}
        <h3 className={styles.title}>{title}</h3>
      </div>
      {children}
    </div>
  )
}

Step.propTypes = propTypes

export default Step



// WEBPACK FOOTER //
// ./src/components/premium/Step.jsx